// 引入axios
import axios from 'axios';
import qs from 'qs'


let baseUrl = "/api/";
// 创建axios实例
const httpService = axios.create({
    baseURL: baseUrl,
    timeout: 1000 * 60 * 30, // 30分钟超时（大文件上传需要）
    paramsSerializer: params => qs.stringify(params, { indices: false })
});

// 添加请求拦截器
httpService.interceptors.request.use(function (config) {
    // 设置token
    config.headers.AUTHORIZATION = window.sessionStorage.getItem('token');

    // 处理用户信息
    const userStr = window.sessionStorage.getItem('user');
    if (userStr && typeof userStr === 'string') {
        try {
            config.headers['X-User-Info'] = encodeURIComponent(userStr);
        } catch (error) {
            console.error('用户信息编码失败:', error);
            delete config.headers['X-User-Info'];
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 添加响应拦截器
httpService.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

/* 网络请求方法 */

// GET请求
export function get(url, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'get',
            params: params,
            ...config  // 扩展配置项，如responseType、headers等
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

// POST请求
export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'post',
            data: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

// PUT请求（用于全量更新资源）
export function put(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'put',
            data: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

// PATCH请求（用于部分更新资源）
export function patch(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'patch',
            data: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

// DELETE请求
export function del(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'delete',
            data: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

// 请求器中 fileUpload 方法调整（显式设置 Content-Type 为 multipart/form-data）
export function fileUpload(url, params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data'  // 显式设置文件上传头
      },
      ...config
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}

export function getServerUrl() {
    return baseUrl;
}

export default {
    get,
    post,
    put,
    patch, // 导出PATCH请求方法
    del,
    fileUpload,
    getServerUrl
}